// @flow

/* Layouts */
export const LAYOUT_SIDEBAR = {
    RESPONSIVE_SIDEBAR: {
        collapsedHeight: '58px',
    },
};
